import React from 'react';
import { Card, CardContent } from './ui/card';
import { Headphones, ShieldCheck, Cpu } from 'lucide-react';

const WhyTMCSection = () => {
  const reasons = [
    {
      number: '1',
      icon: Headphones,
      title: 'Suporte Próprio 24/7',
      description: 'COR (Centro Operacional de Rede) próprio com técnicos especializados em telecomunicações',
      color: 'from-blue-500 to-blue-600'
    },
    {
      number: '2',
      icon: ShieldCheck,
      title: 'SLA Garantido',
      description: 'Disponibilidade de 99,99% com compensações em contrato para downtime',
      color: 'from-green-500 to-green-600'
    },
    {
      number: '3',
      icon: Cpu,
      title: 'Tecnologia de Ponta',
      description: 'Equipamentos modernos e infraestrutura redundante em múltiplos pontos',
      color: 'from-purple-500 to-purple-600'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Por Que Escolher a TMC?
          </h2>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <Card className="h-full hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group overflow-hidden relative bg-[#f1f1f1] border-none">
                  {/* Number Badge on Top */}
                  <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 z-10">
                    <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${reason.color} flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300`}>
                      <span className="text-white font-black text-4xl">{reason.number}</span>
                    </div>
                  </div>

                  <CardContent className="p-8 pt-16">
                    {/* Title with Icon */}
                    <div className="flex items-center justify-center space-x-3 mb-6">
                      <Icon className="w-6 h-6 text-[#0079be]" />
                      <h3 className="text-2xl font-bold text-gray-900 text-center">
                        {reason.title}
                      </h3>
                    </div>

                    <p className="text-gray-700 leading-relaxed text-lg text-center">
                      {reason.description}
                    </p>
                  </CardContent>
                </Card>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyTMCSection;
